import { createSelector } from '@app/utils/createSelector'
import type { RelatedApp } from '@app/utils/getInstalledRelatedApps'
import { getInstalledRelatedApps } from '@app/utils/getInstalledRelatedApps'

import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { createReduxSlice } from '@app/store/redux_slice'

const relatedAppsSlice = createReduxSlice<SliceState<RelatedApp[]>>('related_apps')

export const relatedAppsThunkSelector = createSelector([relatedAppsSlice.selector], state =>
  createLoadable(c => {
    return withCheckedSliceState(c, {
      sliceState: state,
      slice: relatedAppsSlice,
      load: async () => {
        const apps = await getInstalledRelatedApps()
        return apps
      },
    })
  })
)
